<div class="middle-content-wrap">
    <div *ngIf="loading" class="text-center pt-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

    <div *ngIf="!loading && analyticsData" class="container-fluid">
        <div class="row">
            <div class="col-md-12 mb-4">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Like Behavior Analytics</h4>
                        <p class="card-category">Analysis of received likes vs sent likes before subscription</p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-end align-items-center">
                                <label class="mr-3 mb-0 font-weight-bold">All Historical Users</label>
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleUserType($event)" [checked]="isActiveUsers">
                                    <span class="slider round"></span>
                                </label>
                                <label class="ml-3 mb-0 font-weight-bold">Currently Active Users</label>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-lg-6 col-md-12 mb-4">
                                <div class="chart-container">
                                    <canvasjs-chart [options]="chartOptionsMale"></canvasjs-chart>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 mb-4">
                                <div class="chart-container">
                                    <canvasjs-chart [options]="chartOptionsFemale"></canvasjs-chart>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-12">
                                <div class="chart-container">
                                    <canvasjs-chart [options]="chartOptionsAll"></canvasjs-chart>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>